import axiosInstance from '@/shared/api/axios';
import type {
  ApiSupportChatGetResponse,
  ApiSupportChatMessagePostBody,
  ApiSupportChatMessagesGetResponse,
  ApiSupportFaqsGetResponse,
  ApiSupportMessage,
} from '@/shared/types/api/support';

export const apiFaqsGet = async (): Promise<ApiSupportFaqsGetResponse> => {
  const { data } = await axiosInstance.get<ApiSupportFaqsGetResponse>('/support/faqs');
  return data;
};

export const apiChatGet = async (): Promise<ApiSupportChatGetResponse> => {
  const { data } = await axiosInstance.get<ApiSupportChatGetResponse>('/support/chat');
  return data;
};

export const apiChatMessagesGet = async (
  afterId?: string,
): Promise<ApiSupportChatMessagesGetResponse> => {
  const { data } = await axiosInstance.get<ApiSupportChatMessagesGetResponse>(
    '/support/chat/messages',
    afterId != null ? { params: { after: afterId } } : undefined,
  );
  return data;
};

export const apiChatMessagePost = async ({
  text,
  file,
}: ApiSupportChatMessagePostBody): Promise<ApiSupportMessage> => {
  if (file) {
    const formData = new FormData();
    if (text) formData.append('text', text);
    formData.append('file', file);
    // Content-Type undefined → the browser sets multipart/form-data with the boundary.
    const { data } = await axiosInstance.post<ApiSupportMessage>(
      '/support/chat/messages',
      formData,
      { headers: { 'Content-Type': undefined } },
    );
    return data;
  }
  const { data } = await axiosInstance.post<ApiSupportMessage>('/support/chat/messages', { text });
  return data;
};
